module.exports = __webpack_public_path__ + "static/img/icon_gift_eng.5df0443a.svg";